<template>
  <button
    v-if="isScheduleEnabled || config.timing === 'scheduled'"
    @click="openSchedule"
    class="flex items-center gap-3 bg-white hover:bg-gray-50 px-5 py-2.5 rounded-full text-sm font-medium text-gray-700 transition-all border border-gray-200 hover:border-primary-300 hover:text-primary-700 group w-full sm:w-auto justify-between sm:justify-start whitespace-nowrap"
  >
    <div class="flex items-center gap-2">
      <Clock
        :size="18"
        class="text-primary-600 group-hover:scale-110 transition-transform"
      />
      <span class="font-bold">
        {{
          effectiveTiming === "asap"
            ? "ASAP"
            : `${config.scheduledDay || "Today"}, ${config.scheduledTime || ""}`
        }}
      </span>
      <span class="text-xs text-gray-400 font-normal hidden sm:inline">
        ({{ effectiveTiming === "asap" ? "10-15 min" : "Scheduled" }})
      </span>
    </div>
    <ChevronDown :size="16" class="text-gray-400" />
  </button>
</template>

<script>
import { mapGetters } from "vuex";
import { Clock, ChevronDown } from "lucide-vue";
import { useModalManagement } from "@/composables/useModalManagement";
import { useSelectedStore } from "@/composables/useSelectedStore";
export default {
  name: "TimingTrigger",
  components: {
    Clock,
    ChevronDown
  },
  created() {
    this._modalManagement = useModalManagement(this.$store);
    this._selectedStore = useSelectedStore(this.$store);
  },
  computed: {
    ...mapGetters(["getDiningOptionObject", "orderConfig"]),
    isScheduleEnabled() {
      const option = this.getDiningOptionObject;
      return option && option.is_scheduling_enabled === true;
    },
    config() {
      return this.$store.getters.orderConfig;
    },
    /**
     * Checks if the store is in schedule-only mode
     * Returns true if store status is 'schedule_only' or 'closed' (neither can
     * take ASAP orders, so the timing is effectively scheduled).
     */
    isScheduleOnlyMode() {
      if (!this._selectedStore) {
        return false;
      }
      const storeStatus = this._selectedStore.getStoreStatus();
      return storeStatus === "schedule_only" || storeStatus === "closed";
    },
    /**
     * Gets the effective timing mode
     * If in schedule-only mode, always return 'scheduled' even if config says 'asap'
     */
    effectiveTiming() {
      if (this.isScheduleOnlyMode) {
        return "scheduled";
      }
      return this.config?.timing || "asap";
    }
  },
  methods: {
    openSchedule() {
      this._modalManagement.setScheduleModalOpen(true);
    }
  }
};
</script>

<style></style>
